import React, { useState, useRef } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';
import GoalStaticsTotalDetailContainer from './GoalStaticsTotalDetailContainer';
import AskDialog from '../../components/common/dialog/AskDialog';

const currentYear = new Date().getFullYear();
const startYear = 2026;
const arrYears = Array.from(
  { length: Math.max(currentYear - startYear + 2, 1) }, 
  (_, i) => startYear + i
);

const GoalStaticsDetailContainer = () => {
  const [selectedYear, setSelectedYear] = useState(2026);
  const [selectedGbn, setSelectedGbn] = useState('total');
  const [visible, setVisible] = useState(false);

  const onCancle = () => setVisible(false);
  const onConfirm = () => setVisible(false);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', my: 2}}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333', mb: 1 }}>
          사업 목표 상세
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center', // 세로 중앙 정렬
          }}
        >
          {/* 좌측: 사업년도 선택 */}
          <Box sx={{ minWidth: 120, mt:2 }}>
            <FormControl variant="outlined" size="small" fullWidth>
              <InputLabel id="selected-year-label">사업년도</InputLabel>
              <Select
                labelId="selected-year-label"
                id="selected-year"
                value={selectedYear}
                label="사업년도"
                onChange={(e) => setSelectedYear(e.target.value)}
                sx={{ fontSize: '0.875rem', backgroundColor: '#fff' }}
              >
                {arrYears.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}년
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Box>
      <Box sx={{ width: '100%' }}>
        {selectedGbn === 'total' && (
          <GoalStaticsTotalDetailContainer
            selectedYear={selectedYear}
            selectedGbn={selectedGbn}
          />
        )}
      </Box>

      <AskDialog
        visible={visible}
        title="검색 오류"
        description="잘못된 검색기간이 설정되었습니다."
        confirmText="확인"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </Box>
  );
};

export default GoalStaticsDetailContainer;
